 import './App.css';
import RootNavigator from "./Routes/RootNavigator/RootNavigator";
import React, { Suspense, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./scss/style.scss";
import { CSpinner } from "@coreui/react-pro";

const loading = (
  // <div className="pt-3 text-center">
  //   <div className="sk-spinner sk-spinner-pulse"></div>
  // </div>
  // <CSpinner color="primary" />
  <div className="spinner-position">
    <CSpinner color="primary" />
  </div>
);

function App() {
  return (
    <>
      <Suspense fallback={loading}>
        <RootNavigator />
      </Suspense>
    </>
  );
}

export default App;
